import { useTranslation } from 'react-i18next'

import { Flex, TertiaryButton } from '@enechain/ecloud-designsystem'
import {
  FaChevronLeftRegular,
  FaChevronRightRegular,
} from '@enechain/ecloud-icons'

import { CompactCivilDateField } from '~/components/common/CompactCivilDateField'
import { iconSize } from '~/constants/iconSize'
import {
  type CivilDate,
  civilDateToDate,
  compareCivilDate,
  dateToCivilDate,
} from '~/models/civilDate'
import { addDays } from '~/models/dateTime'
import { clampToMonth } from '~/pages/SplitSupplyPlan/models/period'

const NS = 'page:splitSupplyPlanDetail' as const

type Props = {
  day: CivilDate
  days: CivilDate[]
  onChange: (day: CivilDate) => void
}

/** 月間の詳細の日送り: [前日][日付][翌日]。 対象月の外には出られない。 自社の通告値と他社の通告値の詳細で共通。 */
export const DayNav = ({ day, days, onChange }: Props): React.ReactElement => {
  const { t } = useTranslation()
  const first = days[0]
  const last = days[days.length - 1]
  const step = (delta: 1 | -1): CivilDate =>
    dateToCivilDate(addDays(civilDateToDate(day), delta))
  const canPrev = first !== undefined && compareCivilDate(day, first) > 0
  const canNext = last !== undefined && compareCivilDate(day, last) < 0
  return (
    <Flex alignItems="center" gap={2}>
      <TertiaryButton
        width="40px"
        aria-label={t('common:filter.prevDay')}
        disabled={!canPrev}
        onClick={() => {
          onChange(step(-1))
        }}
        paddingX={0}
        size="md"
      >
        <FaChevronLeftRegular
          boxSize={iconSize.labeledButton}
          aria-hidden="true"
        />
      </TertiaryButton>
      <CompactCivilDateField
        aria-label={t(`${NS}.dayNav.day`)}
        id="split-supply-detail-day"
        max={last}
        min={first}
        onChange={(d) => {
          if (d !== undefined && first !== undefined) {
            onChange(clampToMonth(d, first))
          }
        }}
        value={day}
      />
      <TertiaryButton
        width="40px"
        aria-label={t('common:filter.nextDay')}
        disabled={!canNext}
        onClick={() => {
          onChange(step(1))
        }}
        paddingX={0}
        size="md"
      >
        <FaChevronRightRegular
          boxSize={iconSize.labeledButton}
          aria-hidden="true"
        />
      </TertiaryButton>
    </Flex>
  )
}
